import axios from 'axios'
import qs from 'qs'

//var baseURL='http://10.6.20.162/'
var baseURL = '/'

//数据ID和景查询
export async function querydataunit(dataid, sceneid, token) {
    var params = {
        dataid: dataid,
        sceneid: sceneid,
        token: token
    }
    let qsdata = qs.stringify(params)
    const res = await axios.post('zkdataquery', qsdata, {
        baseURL: baseURL
    })
    return res
}
export async function servicestatus() {
    const res = await axios.post('servicestatus', "", {
        baseURL: baseURL
    })
    return res
}

// 获得服务器数据、用户综合情况
export async function getoverallinfo()
{
    const res = await axios.post('overallinfo', "", {
        baseURL: baseURL
    })
    return res 
}

export async function mapservtype() //获取底图服务的类型，online或offline
{
    try {
        const res = await axios.post('mapservtype', "", {
            baseURL: baseURL
        })
        return res
    } catch (e) {
        return e;
    }
}
//将该数据加入到购物车
export async function addtocart(dataid) {
    var params = {
        dataid: dataid,
        cmdtype: 'add2cart',
    }

    let qsdata = qs.stringify(params)
    const res = await axios.post('cart', qsdata, {
        baseURL: baseURL
    })
    return res
}

//将该数据从购物车删除 dataid是要删除的数据ID，用户由服务端的session给出
export async function removefromcart(dataid) {
    var params = {
        dataid: dataid,
        cmdtype: 'removefromcart',
    }

    let qsdata = qs.stringify(params)
    const res = await axios.post('cart', qsdata, {
        baseURL: baseURL
    })
    return res
}

//清空购物车，用户由服务端的session给出
export async function removeallfromcart() {
    var params = {
        cmdtype: 'removeallfromcart',
    }

    let qsdata = qs.stringify(params)
    const res = await axios.post('cart', qsdata, {
        baseURL: baseURL
    })
    return res
}

//获取购物车中的数据列表
export async function getdatalistincart() {
    var params = {
        cmdtype: 'getdatalistincart',
    }

    let qsdata = qs.stringify(params)
    const res = await axios.post('cart', qsdata, {
        baseURL: baseURL
    })
    return res
}

//获取图片的基本显示信息
export async function getimginfo(dataid) {
    var params = {
        dataid: dataid,
        cmdtype: 'getinfo',
    }

    let qsdata = qs.stringify(params)
    const res = await axios.post('fetchscene', qsdata, {
        baseURL: baseURL
    })
    return res
}

//获取服务器提供可供查询的卫星名称
export async function getsatellites()
{
    var params = {
        cmdtype: 'supportsatellite',
    }

    let qsdata = qs.stringify(params)
    const res = await axios.post('querydata', qsdata, {
        baseURL: baseURL
    })
    return res
}
//获取数据的详细信息
export async function getmeta(granuleid) {
    var params = {
        granuleid: granuleid,
        cmdtype: 'getmeta',
    }

    let qsdata = qs.stringify(params)
    const res = await axios.post('querydata', qsdata, {
        baseURL: baseURL
    })
    return res
}
//querydata接口,queryparam:是一个对象 包含:起始日期，终止日期，卫星传感器源，空间位置，云量，产品等级
export async function querydata(queryparam) {
    queryparam.cmdtype = 'query'

    //axios post 时用param作为参数，参数长度不能太大。用data作为参数，将参数放到数据体重传输。可以传送长参数。query中地理多边形比较大，用data方式传输
    return axios.request({
        url: 'querydata',
        method: 'post',
        data: queryparam // params参数拼接在 url后面
    })
}

//数据下载接口,下载数据前检查文件是否可以下载
export async function predatadownloadhandler(granuleid) {
    const params = {
        "granuleid": granuleid,
        "cmdtype": "verify"
    }
    let qsdata = qs.stringify(params)
    const res = await axios.post('datadownload', qsdata)
    return res
}

export function POST(URL, PARAMTERS) {

    // //创建form表单
    var temp_form = document.createElement("form");
    temp_form.action = URL;
    //如需打开新窗口，form的target属性要设置为'_blank'
    temp_form.target = "_self"; //"_frameName("+username+")";
    temp_form.method = "post";
    temp_form.style.display = "none";
    //添加参数
    for (var item in PARAMTERS) {
        var opt = document.createElement("textarea");
        opt.name = PARAMTERS[item].name;
        opt.value = PARAMTERS[item].value;
        temp_form.appendChild(opt);
    }
    document.body.appendChild(temp_form);
    //提交数据
    temp_form.submit();
    temp_form.remove();
}